import React from 'react';
import { Input } from '@wix/design-system';

interface GapSizeInputProps {
  onBlur: () => void;
  onEscapePressed: () => void;
  onEnterPressed: (size: number) => void;
  currentHeight: number;
}

const GapHeightInput: React.FC<GapSizeInputProps> = ({
  currentHeight,
  onBlur,
  onEscapePressed,
  onEnterPressed,
}) => {
  return (
    <Input
      defaultValue={currentHeight.toString()}
      size="tiny"
      suffix="px"
      autoFocus={true}
      onBlur={onBlur}
      //@ts-expect-error
      onEnterPressed={(e) => onEnterPressed(Number(e.target.value))}
      onEscapePressed={onEscapePressed}
    />
  );
};

export default GapHeightInput;
